import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getCustomer } from 'redux/customer/actions';

import Customer from './Customer';
// eslint-disable-next-line import/no-cycle
import NoCustomer from './NoCustomer';

const JordanLoyaltyWidget = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  const settings = useSelector((state) => state.setting.data);
  const customerReducer = useSelector((state) => state.customer);
  const { data: customer, isFetching } = customerReducer;

  if (!settings) {
    return null;
  }
  if (isFetching) {
    return <div>Loading</div>;
  }
  if (customer) {
    return <Customer />;
  }

  return <NoCustomer />;
};

export default JordanLoyaltyWidget;
